import { render, staticRenderFns } from "./LPGReport2.vue?vue&type=template&id=69151d66"
import script from "./LPGReport2.vue?vue&type=script&lang=js"
export * from "./LPGReport2.vue?vue&type=script&lang=js"
import style0 from "./LPGReport2.vue?vue&type=style&index=0&id=69151d66&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports